import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IInterventionMaterial } from "../../utils/types/models";

export default createEntityReducer<IInterventionMaterial>(Endpoint.InterventionMaterials, Endpoint.InterventionMaterialsList);
